import type { ObjectProposalGenerationType } from '@econtractor/types';

const isActive = (row: ObjectProposalGenerationType) => !Number(row.deleted || 0);

const hasProposalItems = (row: ObjectProposalGenerationType) =>
    Boolean((row.products || []).length || (row.additionalItems || []).length);

/**
 * Accepted commercial proposal for an object:
 * 1) linked lead КП (always accepted when present in object docs),
 * 2) otherwise accepted object document of type proposal with items.
 */
export const findAcceptedProposal = (
    rows: ObjectProposalGenerationType[] | null | undefined,
): ObjectProposalGenerationType | null => {
    const list = Array.isArray(rows) ? rows.filter(isActive) : [];
    if (!list.length) return null;

    const lead = list.find(
        (row) => (row.source || 'object') === 'lead' && hasProposalItems(row),
    );
    if (lead) return lead;

    return (
        list.find(
            (row) =>
                (row.source || 'object') === 'object' &&
                Boolean(row.proposavAccept) &&
                (row.proposalType === 'proposal' || hasProposalItems(row)) &&
                hasProposalItems(row),
        ) || null
    );
};
